<template>
  <b-col
    cols="8"
    class="px-0"
  >
    <b-row no-gutters>
      <ColorPicker
        v-for="(_, col) in legenditems"
        :key="`legend-color-${col}`"
        v-model="legenditems[col].color"
        :class="`col-${getLegendItemsNumber} px-0`"
      />
    </b-row>
  </b-col>
</template>

<script lang="ts">

import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'

import { ColorPicker } from '@orbica/vue-modules'
import { ComparisonGraphLegendItem } from '@/types'

const components = {
  ColorPicker,
}

const props = {
  legenditems: {
    type: Array as PropType<ComparisonGraphLegendItem[]>,
    required: true,
  },
}

@Component({ components })
export default class LegendColors extends Vue.extend({ props }) {
  get getLegendItemsNumber () {
    return Math.floor(12 / (this.legenditems.length))
  }
}

</script>
